import { trigger, state, style, animate, transition } from '@angular/animations';
import { Component, OnInit, HostListener, ViewEncapsulation } from '@angular/core';
import { MapRendererService } from '../../services/map-renderer.service';

@Component({
  selector: 'search-row',
  templateUrl: './search-row.component.html',
  styleUrls: ['./search-row.component.sass'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        height: '*',
        //display: 'block',
        overflow: 'hidden'
      })),
      state('out', style({
        height: '0px',
        //display: 'none',
        overflow: 'hidden'
      })),
      transition('in => out', animate('500ms ease-in')),
      transition('out => in', animate('500ms ease-in'))
    ])


  ]
})
export class SearchRowComponent implements OnInit {

  public showFilterBlock: boolean = false;
  public animationStateName: string = "in";
  public isDisplayError: boolean = false; // Флаг отображения ошибки
  public currentMessage: string = ''; // Сообщение об ошибке

  constructor(
      private mapService: MapRendererService,
  ) {

    // Подписки на сервисы
    this.mapService.getShowErrorSubject().asObservable().subscribe((e: { isDisplay: boolean, messageText: string }) => {
      if (e) {
        this.showError(e.isDisplay, e.messageText);
      }
    });

  }

  ngOnInit() {

  }


  public showError(toShow: boolean, message: string = '') {
    this.isDisplayError = toShow;
    this.currentMessage = message;
  }

  public captureNewFiltersBlockState(isOpened: boolean) {
    this.showFilterBlock = isOpened;
  }
}
